/**
 * @Description: 路由配置
 * @Date: 2019-9-25
 * @Modify:
 * @Author: zhangxiaofeng
 */
import Layout from '@/components/layout/Index.vue'

export default [
  {
    path: '/preview',
    component: Layout,
    children: [
      {
        path: ':name',
        component: () => import('@/views/preview/Index'),
        meta: { title: '预览', icon: 'home', noCache: true, keepAlive: false, auth: true }
      }
    ]
  }
]
